import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const UploadImage = ({ files, setFiles, update, prop, formik, onFileSelect }) => {
  const onDrop = (acceptedFiles) => {
    setFiles(acceptedFiles[0]);
    if (onFileSelect) {
      const e = { target: { files: acceptedFiles } };
      onFileSelect(e);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': []
    },
    onDrop: onDrop
  });

  const imageUrl = formik.values[prop.name] || files?.preview;

  return (
    <div className="container">
      {/* Image Preview Above */}
      {imageUrl && (
        <div className="selected-file-preview" 
          style={{
            marginBottom: '15px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              width: '150px',
              height: '150px',
              objectFit: 'cover',
              borderRadius: '4px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      )}

      {/* Upload Rectangle Below */}
      <div 
        {...getRootProps({ className: 'dropzone' })} 
        style={{
          border: '2px dashed #cccccc',
          borderRadius: '4px',
          padding: '20px',
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: '#f8f9fa',
          minHeight: '100px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'all 0.3s ease-in-out'
        }}
      >
        <input {...getInputProps()} />
        <div style={{
          color: '#666',
          fontSize: '14px'
        }}>
          <p style={{ margin: 0 }}>
            Drag & drop image here, or click to select image
          </p>
          {imageUrl && (
            <p style={{ 
              margin: '5px 0 0 0',
              fontSize: '12px',
              color: '#888'
            }}>
              Click or drag to replace the image
            </p>
          )}
        </div>
      </div>

      {/* {prop.title && (
        <p className="selected-file-name" style={{
          marginTop: '10px',
          textAlign: 'center',
          fontWeight: '500',
          color: '#444'
        }}>
          {prop.title}
        </p>
      )} */}
    </div>
  );
};

export default UploadImage;